<template>
  <div>
    <EmailConfigForm :data="emailData" @submit="editConfiguration"/>
  </div>
</template>
<script>
  import EmailConfigForm from './EmailConfigForm'
  import EmailConfigService from 'src/services/EmailConfigService'
  export default {
    components: {
      EmailConfigForm
    },
    data() {
      return {
        emailData: {}
      }
    },
    methods: {
      async editConfiguration(data) {
        await EmailConfigService.update(this.$route.params.id, data)
        this.$router.push({ name: 'settings_email-configuration' })
      }
    },
    async mounted() {
      let {data} = await EmailConfigService.getById(this.$route.params.id)
      this.emailData = data
    }
  }
</script>
<style>
</style>
